import React, { Fragment } from 'react'

import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import { withStyles } from '@material-ui/core/styles'

import TrapMapIcon from 'components/atoms/TrapMapIcon'
import MapControls from 'components/molecules/MapControls'
import HeatmapHelper from 'components/atoms/HeatmapHelper'
import InfoTrapLabel from 'components/atoms/InfoTrapLabel'
import MapPlaceholder from 'components/atoms/MapPlaceholder'

import { getGoogleApiKey } from 'utils/misc'

const defaultZoom = 15
const defaultCenter = {
  lat: -37.9259507,
  lng: 175.9140038,
}

const styles = () => ({
  root: {
    minHeight: 400,
    position: 'relative',
    height: 'calc(100vh - 309px)',
  },
  controls: {
    top: 40,
    left: 40,
    zIndex: 10,
    position: 'absolute',
  },
  placeholder: {
    top: 0,
    left: 0,
    position: 'absolute',
  },
})

const GroupTrapMap = ({
  data,
  loaded,
  classes,
  onChange,
  infoTipY,
  infoTipX,
  mapTypeId,
  onApiLoad,
  infoTipTrap,
  heatmapOpen,
  focusedTrap,
  focusedGroup,
  onTilesLoaded,
  toggleHeatmap,
  handleMapZoom,
  getMapOptions,
  handleMapReset,
  handleTrapClick,
}) => (
  <div className={classes.root}>
    {data && data.groupLineDetails && data.groupLineDetails.length && (
      <Fragment>
        <GoogleMapReact
          onChange={onChange}
          mapTypeId={mapTypeId}
          options={getMapOptions}
          defaultZoom={defaultZoom}
          defaultCenter={defaultCenter}
          onTilesLoaded={onTilesLoaded}
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{
            key: getGoogleApiKey(),
            libraries: 'visualization',
          }}
          onGoogleApiLoaded={({ map, maps }) => onApiLoad(map, maps)}>
          {!heatmapOpen &&
              data.groupLineDetails.map((trap) => {
                const isGroupActive =
                  (!focusedGroup && !focusedTrap) ||
                  focusedGroup === trap.groupUuid
                const isTrapActive =
                  (!focusedTrap && !focusedGroup) ||
                  isGroupActive ||
                  focusedTrap === trap.trapUuid

                return (
                  <TrapMapIcon
                    trap={trap}
                    key={trap.historyUuid}
                    lat={trap.latitude}
                    lng={trap.longitude}
                    isActive={isTrapActive}
                    onClick={handleTrapClick}
                  />
                )
              })}
        </GoogleMapReact>
        <MapControls
          handleZoom={handleMapZoom}
          heatmapActive={heatmapOpen}
          className={classes.controls}
          handleReset={handleMapReset}
          handleHeatmapToggle={toggleHeatmap}
        />
        <HeatmapHelper open={heatmapOpen} />
        {infoTipTrap && (
          <InfoTrapLabel x={infoTipX} y={infoTipY} data={infoTipTrap} />
        )}
      </Fragment>
    )}
    <MapPlaceholder
        isHidden={loaded}
        className={classes.placeholder}
        emptyStateTitle="This group doesn't have any traps"
        emptyStateDescription="Traps that are added to this group will appear here"
        showEmptyState={
            data && data.groupLineDetails && data.groupLineDetails.length === 0
        }
    />
  </div>
)

GroupTrapMap.propTypes = {
  data: PropTypes.object,
  zoom: PropTypes.number,
  loaded: PropTypes.bool,
  onChange: PropTypes.func,
  center: PropTypes.object,
  onApiLoad: PropTypes.func,
  classes: PropTypes.object,
  infoTipY: PropTypes.number,
  infoTipX: PropTypes.number,
  heatmapOpen: PropTypes.bool,
  mapTypeId: PropTypes.string,
  tilesLoaded: PropTypes.bool,
  activeTrap: PropTypes.string,
  infoTipTrap: PropTypes.object,
  onTilesLoaded: PropTypes.func,
  activeGroup: PropTypes.string,
  focusedTrap: PropTypes.string,
  toggleHeatmap: PropTypes.func,
  handleMapZoom: PropTypes.func,
  getMapOptions: PropTypes.func,
  focusedGroup: PropTypes.string,
  handleMapReset: PropTypes.func,
  handleTrapClick: PropTypes.func,
}

export default withStyles(styles)(GroupTrapMap)



// WEBPACK FOOTER //
// ./src/components/organisms/GroupTrapMap/GroupTrapMap.js